/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stat_ReboundsInputs */

const th_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รีบาวด์`)
};

const en_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebounds`)
};

const ja_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リバウンド`)
};

const zh_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`篮板`)
};

const es_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebotes`)
};

const pt_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebotes`)
};

const id_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebound`)
};

const fr_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebonds`)
};

const tl_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebound`)
};

const vi_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt bóng bật bảng`)
};

const ko_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`리바운드`)
};

const de_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebounds`)
};

const ru_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подборы`)
};

const tr_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ribaunt`)
};

const it_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimbalzi`)
};

const pl_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zbiórki`)
};

const uk_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підбирання`)
};

const hi_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिबाउंड`)
};

const ar_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المرتدات`)
};

const ms_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebaun`)
};

const bn_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিবাউন্ড`)
};

const zh_tw2_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`籃板`)
};

const zh_hk2_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`籃板`)
};

const ur_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ری باؤنڈ`)
};

const fa_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ریباند`)
};

const sw_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ridundo`)
};

const nl_stat_rebounds = /** @type {(inputs: Stat_ReboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebounds`)
};

/**
* | output |
* | --- |
* | "Rebounds" |
*
* @param {Stat_ReboundsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const stat_rebounds = /** @type {((inputs?: Stat_ReboundsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stat_ReboundsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_stat_rebounds(inputs)
	if (locale === "ja") return ja_stat_rebounds(inputs)
	if (locale === "zh") return zh_stat_rebounds(inputs)
	if (locale === "es") return es_stat_rebounds(inputs)
	if (locale === "pt") return pt_stat_rebounds(inputs)
	if (locale === "id") return id_stat_rebounds(inputs)
	if (locale === "fr") return fr_stat_rebounds(inputs)
	if (locale === "tl") return tl_stat_rebounds(inputs)
	if (locale === "vi") return vi_stat_rebounds(inputs)
	if (locale === "ko") return ko_stat_rebounds(inputs)
	if (locale === "de") return de_stat_rebounds(inputs)
	if (locale === "ru") return ru_stat_rebounds(inputs)
	if (locale === "tr") return tr_stat_rebounds(inputs)
	if (locale === "it") return it_stat_rebounds(inputs)
	if (locale === "pl") return pl_stat_rebounds(inputs)
	if (locale === "uk") return uk_stat_rebounds(inputs)
	if (locale === "hi") return hi_stat_rebounds(inputs)
	if (locale === "ar") return ar_stat_rebounds(inputs)
	if (locale === "ms") return ms_stat_rebounds(inputs)
	if (locale === "bn") return bn_stat_rebounds(inputs)
	if (locale === "zh-TW") return zh_tw2_stat_rebounds(inputs)
	if (locale === "zh-HK") return zh_hk2_stat_rebounds(inputs)
	if (locale === "ur") return ur_stat_rebounds(inputs)
	if (locale === "fa") return fa_stat_rebounds(inputs)
	if (locale === "sw") return sw_stat_rebounds(inputs)
	if (locale === "nl") return nl_stat_rebounds(inputs)
	return en_stat_rebounds(inputs)
});